import { Col, Row } from "react-bootstrap";
import BadgeFitprenda from "./Badge";
import "./MainSectionTitle.css";

const MainSectionTitle = (props: any) => {
  return (
    <>
      <Row>
        <Col>
          <p
            className="main-content-fitprenda-title"
            style={{ marginBottom: "0.3rem" }}
          >
            {props.title ? props.title : ""}{" "}
            {props.badgeValue ? (
              <BadgeFitprenda
                value={props.badgeValue}
                variant={props.badgeVariant}
              />
            ) : (
              <></>
            )}
          </p>
        </Col>
      </Row>
      {props.subtitle ? (
        <Row>
          <Col>
            <p className="main-content-fitprenda-subtitle">{props.subtitle}</p>
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </>
  );
};

export default MainSectionTitle;
